<template>
  <div id="forgotpassword-view">
    <section class="">
      <div class="d-flex justify-content-center">
        <img
          src="@/assets/site/images/loader.gif"
          v-if="loader === true"
          class="img-fluid loader-width"
          alt
        />
      </div>
      <div class="container" v-if="loader === false">
        <img
          class=""
          src="@/assets/site/images/chair.png"
          style="width: 25%; position: absolute; right: 70%"
          alt=""
        />
        <img
          class="swing"
          src="@/assets/site/images/chair_2.png"
          style="width: 30%; position: absolute; left: 65%"
          alt=""
        />
        <div class="card" style="border: none !important">
          <h1 class="card-title">
            <img src="@/assets/site/images/grey.png" class="img-fluid" alt="" />
          </h1>
          <h3>Forgot Password</h3>
          <form class="card-form">
            <b-alert show :variant="color" v-if="response_message != null">
              {{ response_message }}
            </b-alert>
            <label for="username">Enter Your Email Address</label>
            <div class="card-input-container username">
              <input
                type="text"
                placeholder="Enter Your Email Address"
                v-model="email"
                id="username"
                @blur="validateEmail('email')"
              />
              <span class="text-danger" v-if="errors.email">{{
                this.errors.email[0]
              }}</span>
            </div>
            <div class="row">
              <div class="col-8">
                <span class="text-danger">{{ error_msg }}</span>
              </div>
            </div>
            <button
              @click="sendForgotPasswordMail"
              type="button"
              class="card-button"
            >
              Send Email
            </button>

            <!-- <p style="font-size: 14px">
              Don’t have an account?
              <router-link to="/signup"> Sign Up</router-link> |
              <router-link to="/site" exact style="font-size: 14px"
                >Login</router-link
              >
            </p> -->
          </form>
        </div>
      </div>
     
    </section>
  </div>
</template>

<script>
export default {
  name: "ForgotpasswordView",
  data() {
    return {
      email: null,
      errors: [],
      response_message: null,
      loader: false,
      color: "success",
      error_msg:null
    };
  },
  methods: {
    validateEmail(field) {
    // Validate and update error message
    const emailRegex = /^\S+@\S+\.\S+$/; // Regular expression for a valid email address
    if (!this[field].trim()) {
        this.$set(this.errors, field, ['Email is required.']);
      }
    else if (!emailRegex.test(this[field])) {
      this.$set(this.errors, field, ['Invalid email format.']);
    } else {
      this.$set(this.errors, field, null);
    }
  },
    sendForgotPasswordMail() {
      //Save or update User Details
      this.errors = [];
      this.response_message = null;
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "api/sendForgotPasswordMail";
      let method_type = "POST";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          email: this.email,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          if (data.status === true) {
            this.color = "success";
            this.response_message = data.message;
            this.email = null;
          } else if (data.status === false) {
            this.color = "danger";
            this.response_message = data.message;
          } else {
            this.errors = data.errors;
          }
        })
        .catch(function (err) {
          console.log("User Data", "Error : " + err.message, "error");
        });
    },
  },
};
</script>